/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import Switch from "@mui/material/Switch";
import { useAgencyInfo } from "context/agency";
import { useUpdateAgencyConfig } from "queries/configurator";

// Same field style used across the other Branding tabs
const fieldStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  fontSize: "16px",
  outline: "none",
};
const defaultFaqs = [
  { enabled: true, question: "", answer: "" },
  { enabled: true, question: "", answer: "" },
  { enabled: true, question: "", answer: "" },
  { enabled: true, question: "", answer: "" },
];

function FAQ() {
  const [agency, Update] = useAgencyInfo();
  const [faqs, setFaqs] = useState(defaultFaqs);
  const [loading, setLoading] = useState(false);

  // Load saved FAQs coming from the backend (agency.plans_faqs)
  useEffect(() => {
    if (Array.isArray(agency?.plans_faqs) && agency.plans_faqs.length) {
      setFaqs(agency.plans_faqs);
    }
  }, [agency]);

  const handleToggleFaq = (index) =>
    setFaqs((prev) =>
      prev.map((faq, i) => (i === index ? { ...faq, enabled: !faq.enabled } : faq))
    );

  const handleChangeField = (index, field) => (event) => {
    const { value } = event.target;
    setFaqs((prev) => prev.map((faq, i) => (i === index ? { ...faq, [field]: value } : faq)));
  };

  const saveFaqsMutation = useUpdateAgencyConfig(true);

  const handleSaveClick = async () => {
    setLoading(true);
    try {
      const { response } = await saveFaqsMutation.mutateAsync({ _id: agency?._id, plans_faqs: faqs });
      if (response) {
        Update(response.data);
      }
    } catch (error) {
      console.log("An error occurred while saving FAQs");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "block" }}>
      <div style={{ marginTop: "16px" }}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              border: "1px solid rgba(229, 229, 229, 1)",
              borderRadius: "15px",
              padding: "16px",
              marginTop: index === 0 ? "0" : "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <p style={{ color: "black", fontWeight: "bold" }}>FAQ {index + 1}</p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: "13px", color: "black", marginRight: "4px" }}>
                  {faq.enabled ? "On" : "Off"}
                </span>
                <Switch
                  checked={faq.enabled}
                  onChange={() => handleToggleFaq(index)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#000 !important",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#000 !important",
                      opacity: 1,
                    },
                  }}
                />
              </div>
            </div>

            <div style={{ width: "100%", marginBottom: "16px" }}>
              <Typography sx={{
                display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "bold"
              }} variant="paragraph">
                Question
              </Typography>
              <input
                type="text"
                placeholder="Enter a question"
                value={faq.question}
                onChange={handleChangeField(index, "question")}
                style={fieldStyle}
              />
            </div>

            {/* Answer */}
            <div style={{ width: "100%" }}>
              <Typography sx={{ display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "bold" }} variant="paragraph">
                Answer
              </Typography>
              <textarea
                rows={3}
                placeholder="Enter an answer"
                value={faq.answer}
                onChange={handleChangeField(index, "answer")}
                style={{ ...fieldStyle, resize: "vertical", fontFamily: "inherit" }}
              />
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px", width: "100%" }}>
        <Button
          onClick={handleSaveClick}
          disabled={loading}
          variant="contained"
          color="primary"
          sx={{ marginTop: "10px" }}
        >
          save
        </Button>
      </div>
    </div>
  );
}

export default FAQ;
